import hasWindow from '@Utils/shared/utils/hasWindow';

function getUserAgent() {
  if (!hasWindow()) {
    return '';
  }

  return window.navigator.userAgent;
}

function getUserAgentData() {
  if (!hasWindow()) {
    return '';
  }

  return window.navigator.userAgentData;
}

/**
 * @param hints available params ["architecture", "model", "bitness", "platformVersion",
     "fullVersionList"]
 * @returns Promise  with an object containing the specific values.
 */
export function getHighEntropyValues(hints: string[]) {
  const userAgentData = getUserAgentData();

  if (
    userAgentData &&
    'getHighEntropyValues' in userAgentData &&
    userAgentData.getHighEntropyValues
  ) {
    return userAgentData.getHighEntropyValues(hints);
  } else {
    return undefined;
  }
}

export function isIE() {
  return /MSIE|Trident/.test(getUserAgent());
}

export function isPuffin() {
  return /(puffin)\/([\w\\.]+)/i.test(getUserAgent());
}

export function isChrome() {
  if (!hasWindow()) {
    return false;
  }

  const regex = /(?!Chrom.*OPR)Chrom(?:e|ium)\/([0-9\.]+)(:?\s|$)/;
  return regex.test(getUserAgent());
}

export function isMac() {
  return getUserAgent().indexOf('Mac OS X') !== -1;
}

export function isAndroid() {
  return /(android)/i.test(getUserAgent());
}

export function isIpad() {
  const ua = getUserAgent();
  return ua.indexOf('ipad') > -1 || (ua.indexOf('macintosh') > -1 && 'ontouchend' in document);
}

export function isIOS() {
  const userAgent = getUserAgent();
  const isIpad =
    userAgent.indexOf('ipad') > -1 ||
    (userAgent.indexOf('Macintosh') > -1 && 'ontouchend' in document);
  return isIpad || /iPad|iPhone|iPod/.test(userAgent);
}

export function isTouch() {
  if (!hasWindow()) {
    return false;
  }
  return (
    'ontouchstart' in window ||
    navigator.maxTouchPoints > 0 ||
    (navigator as any).msMaxTouchPoints > 0
  );
}
